/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon64Regular = forwardRef('NetConnectWifiIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M47.627 17.362A38 38 0 0 0 3.49 26.875a1.5 1.5 0 0 1-2.25-1.983 41 41 0 0 1 61.504-.017 1.5 1.5 0 1 1-2.25 1.985 38 38 0 0 0-12.868-9.498Z" }),
        React.createElement("path", { d: "M32.007 30a22 22 0 0 0-17.128 8.185 1.5 1.5 0 1 1-2.335-1.884 25 25 0 0 1 38.922.012 1.5 1.5 0 0 1-2.336 1.882A22 22 0 0 0 32.007 30Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 43a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-3 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" })));
});
